import PropTypes from 'prop-types';
import React from 'react';

import { Container, Description, ErrorText, InputContainer } from './styledComponents';

import { Input } from '../../../lib/inpulse/Input';

const InputContentModal = ({
  description,
  label,
  value,
  onChange,
  placeholder,
  errorMessage,
  type,
  autoFocus,
  tooltipText,
  readOnly,
}) => (
  <Container>
    {description && <Description>{description}</Description>}
    <InputContainer>
      <Input
        autoFocus={!!autoFocus}
        error={!!errorMessage}
        label={label}
        placeholder={placeholder}
        readOnly={readOnly}
        tooltipText={tooltipText}
        type={type}
        value={value}
        width={240}
        onChange={(e) => onChange(e.target.value)}
      />
      {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
    </InputContainer>
  </Container>
);

InputContentModal.propTypes = {
  description: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  tooltipText: PropTypes.string,
  readOnly: PropTypes.bool,
};

InputContentModal.defaultProps = {
  type: 'text',
  description: null,
};

export default InputContentModal;
